export const MASTER_ROLE = 'master';
export const DISTRIBUTOR_ROLE = 'distributor';
export const ADMIN_ROLE = 'admin';
export const PROFESSIONAL_ROLE = 'professional';
export const DISTRIBUTOR_ADMIN_ROLE = `${DISTRIBUTOR_ROLE}_${ADMIN_ROLE}`;
export const MASTER_ADMIN_ROLE = `${MASTER_ROLE}_${ADMIN_ROLE}`;

export const ROLES = [MASTER_ROLE, DISTRIBUTOR_ROLE, ADMIN_ROLE, PROFESSIONAL_ROLE];
export const ADMIN_AREA_ROLES = [MASTER_ROLE, DISTRIBUTOR_ROLE, ADMIN_ROLE];
